export class TaskOrgLevel {
  taskGroupId: string;
  organizationLevelId: string;
  TaskGroupName?: string;
  OrgLevelName?: string;
}
